const TOKEN_STORE_NAME = 'api-token';
const TOKEN_REQUEST_URL = '/get-auth-token/';

// We import Vue here to use the 'global' axios instance with set baseURL
import Vue from 'vue'

const authModule = {
    namespaced: true,
    state: {
        authToken: localStorage.getItem(TOKEN_STORE_NAME) || null
    },
    mutations: {
        setToken(state, token){state.authToken = token;}
    },
    actions: {
        login({commit}, credentials){
            return new Promise((resolve, reject) => {
                Vue.prototype.axios({
                    url: TOKEN_REQUEST_URL,
                    method: 'POST',
                    data: credentials
                })
                .then(resp => {
                    commit('setToken', resp.data.token);
                    localStorage.setItem(TOKEN_STORE_NAME, resp.data.token);
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                })
            });
        },
        logout({commit}){
            return new Promise((resolve, reject) => {
                commit('setToken', null);
                localStorage.removeItem(TOKEN_STORE_NAME);
                resolve();
            });
        }
    },
    getters: {
        getToken(state){ return state.authToken; },
        isLoggedIn(state){ return state.authToken !== null; }
    }
}

export default authModule;
